export default __webpack_public_path__ + "de42b7cb0e741036570a232019d325b3.png";